import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { ChevronDown } from "lucide-react";

const AdminReport = () => {
  const [selectedPeriod, setSelectedPeriod] = useState("This Week");

  const data = [
    {
      date: "25 Dec",
      Assigned: 150,
      "In-Progress": 90,
      "Approved": 120,
      Rejected: 60,
    },
    {
      date: "26 Dec",
      Assigned: 180,
      "In-Progress": 110,
      "Approved": 140,
      Rejected: 100,
    },
    {
      date: "27 Dec",
      Assigned: 200,
      "In-Progress": 100,
      "Approved": 150,
      Rejected: 70,
    },
    {
      date: "28 Dec",
      Assigned: 160,
      "In-Progress": 120,
      "Approved": 170,
      Rejected: 90,
    },
    {
      date: "29 Dec",
      Assigned: 210,
      "In-Progress": 130,
      "Approved": 180,
      Rejected: 80,
    },
    {
      date: "30 Dec",
      Assigned: 250,
      "In-Progress": 140,
      "Approved": 190,
      Rejected: 100,
    },
    {
      date: "31 Dec",
      Assigned: 300,
      "In-Progress": 150,
      "Approved": 200,
      Rejected: 110,
    },
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Tabs (Channels, Agents, etc.) */}
      <div className="flex border-b border-gray-200 mb-6">
        {["Tickets", "Reports", "Satisfaction", "Tags"].map((tab) => (
          <button
            key={tab}
            className={`px-6 py-3 text-sm font-medium border-b-2 ${
              tab === "Tickets"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-blue-600"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Ticket created</p>
          <p className="text-2xl font-semibold mt-1">234</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Ticket open</p>
          <p className="text-2xl font-semibold mt-1">172</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Ticket closed</p>
          <p className="text-2xl font-semibold mt-1">24</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">One-touch tickets</p>
          <p className="text-2xl font-semibold mt-1">88.9%</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Reopened tickets</p>
          <p className="text-2xl font-semibold mt-1">2.38%</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Support Performance</p>
          <p className="text-2xl font-semibold mt-1">4.5/5</p>
        </div>
      </div>

      {/* Chart Card */}
      <div className="bg-white border rounded-lg p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <div>
            <h3 className="text-gray-700 font-medium">Tickets Status</h3>
            <div className="flex items-center gap-3 mt-1 text-xs text-gray-500">
              <span className="flex items-center gap-1">
                <span className="w-3 h-3 bg-blue-500 rounded-full"></span> Assigned
              </span>
              <span className="flex items-center gap-1">
                <span className="w-3 h-3 bg-yellow-400 rounded-full"></span>{" "}
                In-Progress
              </span>
              <span className="flex items-center gap-1">
                <span className="w-3 h-3 bg-red-500 rounded-full"></span> Approved
              </span>
              <span className="flex items-center gap-1">
                <span className="w-3 h-3 bg-green-500 rounded-full"></span>{" "}
                Rejected
              </span>
            </div>
          </div>

          {/* Dropdown */}
          <div className="relative">
            <button className="flex items-center gap-1 border border-gray-200 px-3 py-1.5 rounded-md text-sm bg-gray-50 hover:bg-gray-100">
              {selectedPeriod}
              <ChevronDown size={16} className="text-gray-600" />
            </button>
          </div>
        </div>

        {/* Line Chart */}
        <div className="w-full h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="date" axisLine={false} tickLine={false} />
              <YAxis axisLine={false} tickLine={false} />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="Assigned"
                stroke="#2563eb"
                strokeWidth={2.5}
              />
              <Line
                type="monotone"
                dataKey="In-Progress"
                stroke="#facc15"
                strokeWidth={2.5}
              />
              <Line
                type="monotone"
                dataKey="Approved"
                stroke="#ef4444"
                strokeWidth={2.5}
              />
              <Line
                type="monotone"
                dataKey="Rejected"
                stroke="#22c55e"
                strokeWidth={2.5}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default AdminReport;
